export default __webpack_public_path__ + "static/media/Aura-Egg__51.9b70282c.png";